/**
 * Cookie name for storing anonymous user token
 */
export const COOKIE_NAME = '_algolia_user_token'

/**
 * Cookie expiration time 400 days
 */
export const COOKIE_MAX_AGE = 400
